<script context="module" lang="ts">
	import Media from '$lib/components/media/Media.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import Section from '$lib/components/layout/Section.svelte';

	export const config: SectionConfig = {
		collection: 'section_subhero',
		availableFor: ['pages', 'special-pages'],
		query: gql`
      media {
        id
        type
        translations {
            languages_code {
                code
            }
            media_description
        }
      }
			translations {
				languages_code {
					code
				}
				title
				subtitle
			}
      `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		title: string;
		subtitle: string;
		media: any;
	};
</script>

<script lang="ts">
	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section type="full">
	<div class="background" slot="background">
		<div class="background-image-wrapper">
			<Media {...data.media} fit="cover" transform="xl" />
		</div>
	</div>
	<div class="hero-wrapper">
		<div class="hero-text-wrapper">
			{#if data.title}
				<div class="hero-title">{data.title}</div>
			{/if}
			{#if data.subtitle}
				<div class="hero-subtitle">{data.subtitle}</div>
			{/if}
		</div>
	</div>
</Section>

<style lang="scss">
	.hero-wrapper {
		position: relative;
		display: flex;
		align-items: flex-end;
		aspect-ratio: 4 / 1;
		width: 100%;
		height: 100%;
		min-height: 200px;

		.hero-text-wrapper {
			display: flex;
			flex-direction: column;
			color: white;
			padding: v(content-padding);

			.hero-title {
				@include font(h1);
			}

			.hero-subtitle {
				@include font(text);
			}
		}
	}

	.background-image-wrapper {
		position: absolute;
		width: 100%;
		height: 100%;
		filter: brightness(0.8);
		z-index: -1;
	}
</style>
